import ChallengeDescription from './ChallengeDescription';

export default ChallengeDescription;
